/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Topic_Update_SuccessInputs */

const en_toast_topic_update_success = /** @type {(inputs: Toast_Topic_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic updated successfully`)
};

const nl_toast_topic_update_success = /** @type {(inputs: Toast_Topic_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderwerp succesvol bijgewerkt`)
};

/**
* | output |
* | --- |
* | "Topic updated successfully" |
*
* @param {Toast_Topic_Update_SuccessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_topic_update_success = /** @type {((inputs?: Toast_Topic_Update_SuccessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Topic_Update_SuccessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_topic_update_success(inputs)
	return en_toast_topic_update_success(inputs)
});